import { useContext } from 'react'

import { ParametrizationIncrementSupplierContext } from '@provider/Parametrization/IncrementSupplier'

import { IIncrementSupplierContext } from '@base/@types/providers/Parametrization/IncrementSupplierProvider'

export default function useParametrizationIncrementSupplier(): IIncrementSupplierContext {
  const context = useContext(ParametrizationIncrementSupplierContext)

  return context
}
